/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'
import {useMutation, useQueryClient} from 'react-query'
import {MenuComponent} from '../../../../../../../_metronic/assets/ts/components'
import {ID, KTSVG, QUERIES} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import {Embedding} from '../../core/_models'
import { useAuth } from '../../../../../auth'

type Props = {
  id: ID
  status: boolean
  embedding: Embedding
}

const UserActionsCell: FC<Props> = ({id, status, embedding}) => {
  const userListContext = useListView()
  const loggedInUser:any = useAuth()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const onStatusShow = (action: boolean) => {
    userListContext.setStatusModal(true, action, embedding)
  }

  function handleDownload(path:any) {
    console.log(path);
    const filePath = path;
  
    if (filePath) {
      // Create a virtual anchor element
      const anchor = document.createElement('a');
      anchor.href = filePath;
      anchor.download = getFileNameFromPath(filePath);
  
      // Append the anchor element to the document body
      document.body.appendChild(anchor);
  
      // Trigger the click event on the anchor element
      anchor.click();
  
      // Remove the anchor element from the document body
      document.body.removeChild(anchor);
    }
  }
  
// Function to extract the file name from the file path
function getFileNameFromPath(filePath:any) {
  const lastSlashIndex = filePath.lastIndexOf('/');
  return filePath.substring(lastSlashIndex + 1);
}


  return  (
     <>

      
      <div> 
     
          
          <a
        href='#'
        className='btn btn-light btn-active-light-primary btn-sm'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'>
        Actions
        <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />
      </a>
      {/* begin::Menu */}
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-250px py-4'
        data-kt-menu='true'
      >
        {/* begin::Menu item */}
        <div className='menu-item px-3' onClick={() => userListContext.setItemIdForUpdate(embedding._id)}>
          <div className='menu-link px-3'>Activate Embeddings</div>
        </div>
        <div className='menu-item px-3' onClick={() => handleDownload(embedding.filePath)}>
          <div className='menu-link px-3'>Download File</div>
        </div>
       {embedding.isActive == 'Not Active'? <div className='menu-item px-3' onClick={() => {
          userListContext.setItemIdForUpdate(embedding._id);
          userListContext.setpasswordUpdateCheck(true);
        }}> 
          <div className='menu-link px-3'>Delete Embeddings</div>
        </div> : <></>}
       
      </div> </div>
    </>
  ) 
}

export {UserActionsCell}
